import { formatFullName } from 'platform/shared/health-apps';
import { formatDateLong } from 'platform/utilities/date';
import { scrollToTop } from 'platform/utilities/scroll';
import { focusElement } from 'platform/utilities/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import content from '../../locales/en/content.json';
import Abbr from '../Abbreviation';
import PdfDownloadLink from '../PdfDownloadLink';

const ConfirmationScreenView = ({ name, route, timestamp }) => {
  const veteranFullName = useMemo(() => formatFullName(name), [name]);
  const submissionDate = useMemo(
    () => (timestamp ? formatDateLong(timestamp) : null),
    [timestamp],
  );

  useEffect(() => {
    focusElement('h2', {}, 'va-alert[status="success"]');
    scrollToTop();
  }, []);

  return (
    <>
      <va-alert status="success" class="vads-u-margin-bottom--4">
        <h2 slot="headline">{content['confirmation--alert-heading']}</h2>
        <div>{content['confirmation--alert-text']}</div>
      </va-alert>

      <va-summary-box class="vads-u-margin-bottom--4">
        <h3 slot="headline">{content['confirmation--info-heading']}</h3>

        <h4>{content['confirmation--info-vet-label']}</h4>
        <p data-testid="cg-veteran-fullname" className="dd-privacy-mask">
          {veteranFullName}
        </p>

        {submissionDate && (
          <>
            <h4>{content['confirmation--info-timestamp-label']}</h4>
            <p data-testid="cg-submission-date">{submissionDate}</p>
          </>
        )}

        <h4>{content['confirmation--print-heading']}</h4>
        <p>
          {content['confirmation--print-text']} <Abbr abbrKey="pdf" />.
        </p>

        <div className="vads-u-margin-y--2">
          <va-button
            text={content['button-print']}
            onClick={() => window.print()}
            data-testid="cg-print-button"
          />
        </div>

        <PdfDownloadLink formConfig={route.formConfig} />
      </va-summary-box>
    </>
  );
};

ConfirmationScreenView.propTypes = {
  name: PropTypes.shape({
    first: PropTypes.string,
    middle: PropTypes.string,
    last: PropTypes.string,
    suffix: PropTypes.string,
  }),
  route: PropTypes.shape({
    formConfig: PropTypes.object,
  }),
  timestamp: PropTypes.number,
};

export default ConfirmationScreenView;
